<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>
                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.MANAGE_TEAM_TEXT }}
                                    </h1>
                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }"
                                                    @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="publishedhLink" href="#"
                                                    :class="{ active: activeTab === 'published' }"
                                                    @click="switchView('published')">
                                                    {{ constants.PUBLISHED_LINK }}
                                                    <span>{{ counts.published }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="unPublishedhLink" href="#"
                                                    :class="{ active: activeTab === 'unpublished' }"
                                                    @click="switchView('unpublished')">
                                                    {{ constants.UNPUBLISHED_LINK }}
                                                    <span>{{ counts.unpublished }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="admin-right-sidebar-in-top-right">
                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="seachTeamInput" type="text" placeholder="Search"
                                                v-model="searchedText"
                                                @keyup.enter="fetchTeams(activeTab), fetchCounts(searchedText)" />
                                        </div>
                                        <div class="admin-add-btn">
                                            <button id="addBlogBtn" class="add-btn-admin" :class="{ 'active': showAddForm }"
                                                @click="showAddForm = true, selectedTeams = [], selectAll = false, cancelEdit()">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_MEMBER_BUTTON }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedTeams.length > 1">
                                        <div class="tags">
                                            <ul>
                                                <li>
                                                    <span>{{ selectedTeams.length }} entries selected</span>
                                                    <button id="tagCloseBtn"
                                                        @click="selectedTeams = [], selectAll = false"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal"
                                                data-bs-target="#deletePop" @click="setDeleteMode('all')">{{
                                                    constants.DELETE_ALL_BUTTON }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAddForm" class="white-bg-border add-new-section">
                            <div class="add-banner-image-section">
                                <h2>
                                    {{ constants.ADD_NEW_TEAM_MEMBER_TEXT }}
                                </h2>
                                <div class="add-banner-image-box">
                                    <form id="addTeamForm" @submit.prevent="submitForm">
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.NAME_LABEL }}
                                            </label>
                                            <input id="memberNameInput" type="text" placeholder="Enter the Name"
                                                v-model="newTeam.name" />
                                            <div class="error-msg" v-if="!newTeam.name">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.EMAIL_LABEL }}
                                            </label>
                                            <input id="memberEmailInput" type="text" placeholder="Enter the Email"
                                                v-model="newTeam.email" />
                                            <div class="error-msg" v-if="!newTeam.email">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.DESIGNATION_LABEL }}
                                            </label>
                                            <input id="memberDesignationInput" type="text"
                                                placeholder="Enter the Designation" v-model="newTeam.designation" />
                                            <div class="error-msg" v-if="!newTeam.designation">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.DESCRIPTION_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Description" class="text-editer" id="descInput"
                                                :editor="editor" v-model="newTeam.description"
                                                :config="editorConfig"></ckeditor>
                                            <div class="error-msg" v-if="!newTeam.description">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.IMAGE_LABEL }}
                                            </label>
                                            <div class="image-upload-input upload-banner-image">
                                                <div
                                                    :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                                                    <div class="file-input-box">
                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                            @click="clearUploadedImage(false)"></button>
                                                        <input type="file" id="addMemberFileInput"
                                                            @change="handleFileUpload($event, false)"
                                                            accept="image/jpeg,image/jpg,image/png" />
                                                    </div>
                                                    <div class="image-upload-input-item-in" v-if="!imageUploaded">
                                                        <div class="image-upload-input-item-icon">
                                                            <img src="@/assets/images/admin-img/image-icon.svg"
                                                                alt="" />
                                                        </div>
                                                        <span>
                                                            {{ constants.ADD_IMAGE_LABEL }}
                                                        </span>
                                                    </div>
                                                    <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                                                        <img :src="imageUrl" alt="" class="mCS_img_loaded">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="error-msg" v-if="!selectedFile">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field-submit">
                                            <button class="admin-btn-outline-primary add-new-cancel" type="submit"
                                                id="submitBtn"  :disabled="isSubmitting">
                                                {{ constants.SUBMIT_BUTTON }}
                                            </button>
                                            <button class="admin-btn-outline-secondary add-new-cancel"
                                                @click="resetForm" type="button" id="cancelBtn">
                                                {{ constants.CANCEL_BUTTON }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div :class="['admin-item-list-section admin-team-section', { 'show-edit-item-outer': editFormSubmitted }]"
                            v-if="editTeamsData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox"
                                                        class="css-checkbox" @change="toggleSelectAll"
                                                        :checked="selectAll === true">
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>
                                            <div class="admin-item-image">
                                                {{ constants.IMAGE_LABEL }}
                                            </div>
                                            <div class="admin-item-team-name" @click="toggleSort('name')" style="cursor: pointer;">
                                                {{ constants.NAME_LABEL }}
                                                <button v-if="sortBy === 'name' || sortBy === '-name'" class="sorting-btn" :class="{ 'sorted': sortBy === '-name' }"></button>
                                            </div>
                                            <div class="admin-item-team-email" @click="toggleSort('email')" style="cursor: pointer;">
                                                {{ constants.EMAIL_LABEL }}
                                                <button v-if="sortBy === 'email' || sortBy === '-email'" class="sorting-btn" :class="{ 'sorted': sortBy === '-email' }"></button>
                                            </div>
                                            <div class="admin-item-team-designation" @click="toggleSort('designation')" style="cursor: pointer;">
                                                {{ constants.DESIGNATION_LABEL }}
                                                <button v-if="sortBy === 'designation' || sortBy === '-designation'" class="sorting-btn" :class="{ 'sorted': sortBy === '-designation' }"></button>
                                            </div> 
                                            <div class="admin-item-team-description" @click="toggleSort('description')" style="cursor: pointer;">
                                                {{ constants.DESCRIPTION_LABEL }}
                                                <button v-if="sortBy === 'description' || sortBy === '-description'" class="sorting-btn" :class="{ 'sorted': sortBy === '-description' }"></button>
                                            </div>
                                            <div class="admin-item-actions">
                                                {{ constants.ACTIONS_LABEL }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="admin-item-list-btm">
                                        <div ref="sortableList"> 
                                            <div v-for="(team, index) in editTeamsData" :key="team.id"
                                                :class="['admin-item-box', { 'show-edit-item': team.editing }]">
                                                <div class="admin-item-box-top">
                                                    <div class="admin-item-list-row">
                                                        <div class="admin-item-checkbox">
                                                            <div class="admin-checkbox-input">
                                                                <input name="cssCheckbox" :id="'demo_opt_' + team.id"
                                                                    type="checkbox" class="css-checkbox"
                                                                    @change="toggleTeamSelection(team.id)"
                                                                    :checked="selectedTeams.includes(team.id)">
                                                                <label :for="'demo_opt_' + team.id"></label>
                                                            </div>
                                                        </div>
                                                        <div class="admin-item-image">
                                                            <div class="sm-img"><img :src="getCdnImageAddress(team.teamMemberImage, `w_40,h_41/`)" alt="" /></div>
                                                        </div>
                                                        <div class="admin-item-team-name">
                                                            <div class="limited-text text-limit">{{ team.name }}</div>
                                                        </div>
                                                        <div class="admin-item-team-email">
                                                            {{ team.email }}
                                                        </div>
                                                        <div class="admin-item-team-designation text-limit">
                                                            {{ team.designation }}
                                                        </div>
                                                        <div class="admin-item-team-description text-limit">
                                                            {{ useStripHtml(team.description) }}
                                                        </div>
                                                        <div class="admin-item-actions">
                                                            <ul class="admin-action-link">
                                                                <li><button id="teamPgEditBtn" class="editBtn"
                                                                        @click="editTeam(index), showAddForm = false">{{
                                                                            constants.EDIT_BUTTON
                                                                        }}</button></li>
                                                                <li>
                                                                    <button data-bs-toggle="modal" id="teamPgDeleteBtn"
                                                                        data-bs-target="#deletePop"
                                                                        @click="setDeleteMode('single', team.id), showAddForm = false, cancelEdit()">
                                                                        {{ constants.DELETE_BUTTON }}
                                                                    </button>
                                                                </li>
                                                                <li><button id="teamPgUnPublishBtn"
                                                                        class="primary-outline-btn" v-if="team.status === 1"
                                                                        @click="changeTeamStatus(team.id, 0)">
                                                                        {{ constants.UNPUBLISH_BUTTON }}
                                                                    </button>
                                                                    <button id="teamPgPublishBtn"
                                                                        class="primary-outline-btn"
                                                                        v-else-if="team.status === 0"
                                                                        @click="changeTeamStatus(team.id, 1)">
                                                                        {{ constants.PUBLISH_BUTTON }}
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="admin-item-box-btm" v-if="team.editing">
                                                    <div class="add-banner-image-section">
                                                        <h2>
                                                            {{ constants.EDIT_TEAM_MEMBER_TEXT }}
                                                        </h2>
                                                        <div class="add-banner-image-box">
                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.NAME_LABEL }}
                                                                </label>
                                                                <input id="memberNameInput" type="text"
                                                                    placeholder="Enter the Name"
                                                                    v-model="editTeamData.name" />
                                                                    <div class="error-msg" v-if="!editTeamData.name">
                                                                    {{
                                                                        errEditMsg }}</div>
                                                            </div>
                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.EMAIL_LABEL }}
                                                                </label>
                                                                <input id="memberEmailInput" type="text"
                                                                    placeholder="Enter the Email"
                                                                    v-model="editTeamData.email" />
                                                                    <div class="error-msg" v-if="!editTeamData.email">
                                                                    {{
                                                                        errEditMsg }}</div>
                                                            </div>
                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.DESIGNATION_LABEL }}
                                                                </label>
                                                                <input id="memberEmailInput" type="text"
                                                                    placeholder="Enter the Email"
                                                                    v-model="editTeamData.designation" />
                                                                    <div class="error-msg" v-if="!editTeamData.designation">
                                                                    {{
                                                                        errEditMsg }}</div>
                                                            </div>
                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.DESCRIPTION_LABEL }}
                                                                </label>
                                                                <ckeditor placeholder="Description" id="descInput"
                                                                    class="text-editer" :editor="editor"
                                                                    v-model="editTeamData.description"
                                                                    :config="editorConfig">
                                                                </ckeditor>
                                                                <div class="error-msg" v-if="!editTeamData.description">
                                                                    {{
                                                                        errEditMsg }}</div>
                                                            </div>
                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.IMAGE_LABEL }}
                                                                </label>
                                                                <div class="image-upload-input upload-banner-image">
                                                                    <div class="image-upload-input-item uploaded-done">
                                                                        <div class="file-input-box">
                                                                            <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                                            @click="clearUploadedImage(true)"></button>
                                                                            <input type="file" id="editMemberFileInputc"
                                                                                @change="handleFileUpload($event, true)"
                                                                                accept="image/jpeg,image/jpg,image/png" />
                                                                        </div>
                                                                        <div class="image-upload-input-item-uploaded">
                                                                            <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="error-msg" v-if="!selectedEditFile && !editimageSrc">
                                                                    {{ errEditMsg }}
                                                                </div>
                                                            </div>
                                                            <div class="admin-input-field-submit">
                                                                <button class="admin-btn-outline-primary" id="submitBtn"
                                                                    @click="submitEditForm(team.id)">
                                                                    {{ constants.SUBMIT_BUTTON }}
                                                                </button>
                                                                <button class="admin-btn-outline-secondary addNewCancel"
                                                                    id="cancelBtn" @click="cancelEdit">
                                                                    {{ constants.CANCEL_BUTTON }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                                v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>
        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i>
                            <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                        </i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import SimpleBar from 'simplebar';
import { vBTooltip } from 'bootstrap-vue-3';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

import Sortable, { SortableEvent } from 'sortablejs';


interface Team {
    id: number;
    name: string;
    email: string;
    designation: string;
    description: string;
    teamMemberImage: string;
    status: number;
    editing?: boolean;
    Created_at?: string;
    position: number; // Add position field
}

export default defineComponent({
    name: "Manage-Team",
    directives: {
        'b-tooltip': vBTooltip
    },
    data() {
        return {
            constants,
            tooltips: [] as Tooltip[],
            errMsg: '',
            errEditMsg: '',
            editor: ClassicEditor,
            activeTab: 'all',
            imageSrc: '',
            searchTempVar: '',
            editimageSrc: '',
            showAddForm: false,
            limit: 10,
            selectedFile: null as File | null,
            selectedEditFile: null as File | null,
            imageUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            teams: [] as Team[],
            editTeamsData: [] as Team[],
            selectedTeams: [] as number[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            counts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable',
                    ]
                },
            },
            newTeam: {
                name: '',
                email: '',
                designation: '',
                description: '',
                teamMemberImage: ''
            },
            editTeamData: {
                name: '',
                email: '',
                designation: '',
                description: '',
                teamMemberImage: ''
            },
            teamToDelete: null as number | null,
            deleteMode: 'all' as 'all' | 'single',
            isSubmitting: false,
            isDragging: false, 
            sortableInstance: null as Sortable | null,
            sortBy: '-position' as string,
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editImage(): string {
            return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
    },
    components: {
        adminHeader,
        adminNavigation
    },
    created() {
        this.limit = getPaginationLimit("manageTeam", 10);
        this.fetchCounts();
        this.fetchTeams()
    },
    mounted() {
        const el = this.$refs.scrollWrapper as HTMLElement;
        if (el) {
            new SimpleBar(el);
        };
        this.initializeTooltips();
        this.setupSortable(); // Initialize SortableJS on mount
    },
    methods: {
        initializeTooltips() {
            const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipElements.forEach((element) => {
                const tooltip = new Tooltip(element);
                this.tooltips.push(tooltip);
            });
        },
        setDeleteMode(mode: any, teamId?: number) {
            this.deleteMode = mode;
            if (teamId !== undefined) {
                this.teamToDelete = teamId;
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteTeam();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false
                this.selectedTeams = []
            }
        },

        handleFileUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editimageSrc = e.target.result;
                            this.selectedEditFile = file;
                        } else {
                            this.imageSrc = e.target.result;
                            this.selectedFile = file;
                            this.imageUploaded = true
                        }
                    }
                };
            }
        },
        toggleTeamSelection(teamId: number) {
            if (this.selectedTeams.includes(teamId)) {
                this.selectedTeams = this.selectedTeams.filter(id => id !== teamId);
            } else {
                this.selectedTeams.push(teamId);
            }


        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedTeams = [];
                this.selectAll = false
            } else {
                this.selectedTeams = this.editTeamsData.map(team => team.id);
                this.selectAll = true
            }
        },
        async submitForm() {
    if (!this.newTeam.name || !this.newTeam.description
        || !this.newTeam.email
        || !this.newTeam.designation || !this.selectedFile
    ) {
        this.errMsg = "All Fields Are Required";
        return;
    }
    this.isSubmitting = true;
    const formData = new FormData();
    formData.append('name', this.newTeam.name);
    formData.append('description', this.newTeam.description);
    formData.append('email', this.newTeam.email);
    formData.append('designation', this.newTeam.designation);
    formData.append('teamMemberImage', this.selectedFile);

    try {
        const response = await fetch(`${API_BASE_URL}/teammember/`, {
            method: 'POST',
            body: formData
        });
        await response.json();
        this.resetForm();
        await this.fetchCounts(); // Fetch counts first
        // Adjust currentPage if needed
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
            this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
        }
        await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Fetch teams with current limit
        this.imageUploaded = false;
        Swal.fire({
            icon: 'success',
            title: 'Team Created Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error) {
        console.error('Error submitting team:', error);
    } finally {
        this.isSubmitting = false;
    }
},
async deleteSelectedContacts() {
    try {
        await axios.delete(`${API_BASE_URL}/teammember/bulk_delete/`, { data: { ids: this.selectedTeams } });
        this.editTeamsData = this.editTeamsData.filter(team => !this.selectedTeams.includes(team.id));
        this.selectedTeams = [];
        await this.fetchCounts(); // Update counts
        await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh teams
        if (this.editTeamsData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.selectAll = false;
    } catch (error) {
        console.error('Error deleting contacts:', error);
    }
},
        async submitEditForm(teamId: number) {
    if (!this.editTeamData.name || !this.editTeamData.description
        || !this.editTeamData.email || !this.editTeamData.designation || (!this.selectedEditFile && !this.editimageSrc)
    ) {
        this.errEditMsg = "All Fields Are Required";
        return;
    }
    const formData = new FormData();
    formData.append('name', this.editTeamData.name);
    formData.append('description', this.editTeamData.description);
    formData.append('email', this.editTeamData.email);
    formData.append('designation', this.editTeamData.designation);
    if (this.selectedEditFile) {
        formData.append('teamMemberImage', this.selectedEditFile);
    }

    try {
        const response = await axios.patch(`${API_BASE_URL}/teammember/${teamId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        this.cancelEdit();
        this.editFormSubmitted = false;
        Swal.fire({
            icon: 'success',
            title: 'Team Updated Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error) {
        console.error('Error updating team:', error);
    }
},

handleLimitChange() {
    setPaginationLimit("manageTeam", this.limit);
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
    this.selectAll = false;
    this.selectedTeams = [];
    this.fetchTeams(this.activeTab, this.limit, 0);
},
// @ts-expect-error
        async fetchTeams(status = 'all', limit?: number, skip = 0, sortBy = this.sortBy) {
    const effectiveLimit = limit ?? this.limit;

    let url = `${API_BASE_URL}/teammember/`;
    const params = new URLSearchParams();
    if (status === 'published') params.append('status', '1');
    else if (status === 'unpublished') params.append('status', '0');

    // Only reset currentPage for a new search, preserve limit
    if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
    }
    if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = '';
    }

    params.append('limit', effectiveLimit.toString());
    params.append('skip', skip.toString());
    if (this.searchedText) {
        params.append('searchedText', this.searchedText);
    }
    params.append('sort_by', sortBy);

    try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editTeamsData = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit); // Update totalPages
        console.log('Teams Fetched:', this.editTeamsData.length, 'Total Pages:', this.totalPages); // Debug log
        this.setupSortable();
    } catch (error) {
        console.error('Error fetching teams:', error);
    }
},
async switchView(status: string) {
    this.currentPage = 1;
    this.activeTab = status;
    this.selectedTeams = [];
    this.selectAll = false;
    this.editFormSubmitted = false;
    await this.fetchTeams(status, this.limit, 0); // Use current limit
    if (status === 'published') {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
    } else if (status === 'unpublished') {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
    } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
    }
},
        resetForm() {
            this.newTeam = {
                name: '',
                description: '',
                email: '',
                designation: '',
                teamMemberImage: ''
            };
            this.selectedFile = null;
            this.imageSrc = '';
            this.showAddForm = false;
            this.errMsg = '';
            this.imageUploaded = false;
        },
        async fetchCounts(searchedText?: string) {
    try {
        const baseUrl = `${API_BASE_URL}/teammember/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';
        const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
            axios.get(`${baseUrl}${queryParam}0&status=1`),
            axios.get(`${baseUrl}${queryParam}1`),
            axios.get(`${baseUrl}${queryParam}0`)
        ]);

        this.counts = {
            all: allResponse.data.count,
            published: publishedResponse.data.count,
            unpublished: unpublishedResponse.data.count
        };

        if (this.activeTab in this.counts) {
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit); // Use this.limit instead of 10
            console.log('Counts:', this.counts, 'Total Pages:', this.totalPages, 'Limit:', this.limit); // Debug log
        } else {
            console.error(`Invalid active tab: ${this.activeTab}`);
        }
    } catch (error) {
        console.error('Error fetching team counts:', error);
    }
},


        editTeam(index: number) {
            this.editTeamsData.forEach((team, i) => {
                team.editing = i === index;
            });
            this.editFormSubmitted = true;
            const selectedTeam = this.editTeamsData[index];
            this.editTeamData = {
                name: selectedTeam.name,
                description: selectedTeam.description,
                email: selectedTeam.email,
                designation: selectedTeam.designation,
                teamMemberImage: selectedTeam.teamMemberImage || ''
            };
            // Use getCdnImageAddress to ensure proper CDN URL
            this.editimageSrc = selectedTeam.teamMemberImage
                ? this.getCdnImageAddress(selectedTeam.teamMemberImage, 'w_200,h_100/')
                : '';

            // Disable SortableJS while editing
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', true);
            }
        },


        cancelEdit() {
            this.editTeamsData.forEach((team) => {
                team.editing = false;
            });
            this.editTeamData = {
                name: '',
                description: '',
                email: '',
                designation: '',
                teamMemberImage: ''
            };
            this.editFormSubmitted = false;
            this.selectedEditFile = null;
            this.editimageSrc = '';
            this.errEditMsg = '';
            // Re-enable SortableJS after canceling edit
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', false);
            }
        },

        async deleteTeam() {
    try {
        await axios.delete(`${API_BASE_URL}/teammember/${this.teamToDelete}/`);
        await this.fetchCounts(); // Update counts
        await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh teams
        if (this.editTeamsData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        (this.$refs.dummyButton as HTMLElement)?.click();
    } catch (error) {
        console.error('Error deleting team:', error);
    }
},

async changeTeamStatus(teamId: number, newStatus: number) {
    try {
        const formData = new FormData();
        formData.append('status', newStatus.toString());

        await axios.patch(`${API_BASE_URL}/teammember/${teamId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchCounts(); // Update counts
        await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh teams
        if (this.editTeamsData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
    } catch (error) {
        console.error('Error updating team status:', error);
    }
},
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content', // Expanded filter
          preventOnFilter: true,
          disabled: this.editFormSubmitted,
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            if (['name', '-name', 'email', '-email', 'designation', '-designation', 'description', '-description'].includes(this.sortBy)) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag   it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newArticlesData = [...this.editTeamsData];
            const [movedItem] = newArticlesData.splice(oldIndex, 1);
            newArticlesData.splice(newIndex, 0, movedItem);

            const totalItems = newArticlesData.length;
            newArticlesData.forEach((item, index) => {
                item.position = totalItems - index;
            });

            // Update reactive property
            this.editTeamsData = newArticlesData;

            // Prepare data for backend sync
            const reorderedItems = newArticlesData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              console.log(reorderedItems,'hhhhhhhhhh')
              await axios.post(`${API_BASE_URL}/teammember/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error('Error updating order:', error);
              await this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });

        console.log('Sortable instance created:', this.sortableInstance);
    });
},
clearUploadedImage(isEdit: boolean) {
	if (isEdit) {
      this.editimageSrc = '';
      this.selectedEditFile = null;
      const fileInput = document.getElementById('editMemberFileInputc') as HTMLInputElement;
      if (fileInput) {
          fileInput.value = '';
      }
	} else {
        this.imageSrc = '';
        this.selectedFile = null;
        this.imageUploaded = false;
        const fileInput = document.getElementById('addMemberFileInput') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    }
},
toggleSort(field: string) {
    if (this.sortBy === field) {
        this.sortBy = `-${field}`; 
    } else if (this.sortBy === `-${field}`) {
        this.sortBy = '-position'; 
    } else {
        this.sortBy = field; 
    }
    this.fetchTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
},
 },  
});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>